Apt.fn.extend('maps', {
	/**
	 * Check map enlargement status
	 *
	 * @returns {Boolean}
	 */
	enlarged() {
		return this.$private.enlarged === true;
	},

	/**
	 * Maximize map
	 */
	maximize() {
		this.$private.maximize();
	},

	/**
	 * Minimize map
	 */
	minimize() {
		this.$private.minimize();
	}
}, {
	/**
	 * Initialize enlargement
	 */
	initResize() {
		const scope = this;

		scope.enlarged = false;

		$.events.on('$mapResize', 'mousedown', () => {
			scope.enlarged ?
				scope.minimize() :
				scope.maximize();
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});
	},

	/**
	 * Maximize map
	 */
	maximize() {
		const scope = this;

		if (scope.enlarged) {
			return;
		}

		scope.enlarged = true;

		scope.$parent[0].classList.add('-is-enlarged');

		scope.model.$set('enlarged', true);

		LS.util.crop();

		requestAnimationFrame(() => {
			scope.map.resize();
		});

		$(document).on('keydown', e => {
			if (
				scope.enlarged &&
				e.keyCode === 27 &&
				! LS.modal.opened() &&
				! Apt.panel.opened()
			) {
				scope.minimize();
			}
		}, {
			namespace: scope.uid
		});

		if (scope.conf.preview) {
			scope.map.dragRotate.enable();
		}
	},

	/**
	 * Minimize map
	 */
	minimize() {
		const scope = this;

		if (! scope.enlarged) {
			return;
		}

		scope.enlarged = false;

		scope.$parent[0].classList.remove('-is-enlarged')

		scope.model.$drop('enlarged');

		LS.util.uncrop();

		scope.$public.resize(() => {
			if (! scope.conf.preview) {
				return;
			}

			scope.resetPitch(true);
			scope.resetCenter();

			if (scope.conf.preview) {
				scope.map.dragRotate.disable();
			}
		});
	}
});